/**
 * User Model Exports
 */

export * from './mock';
export * from './hooks';
export * from './mock-data';
export * from './useProfileHeaderProps';
export * from './validation';

// Re-export rating utilities from lib
export {
  calculateTotalReviews,
  getRatingStats
} from '../lib/ratingUtils';
